export async function setAppBadgeCount(count, badgeNavigator = typeof navigator !== 'undefined' ? navigator : null) {
  if (!badgeNavigator) return false;

  const numericCount = Number(count);
  const hasCount = Number.isFinite(numericCount) && numericCount > 0;

  try {
    if (!hasCount) {
      if (typeof badgeNavigator.clearAppBadge === 'function') {
        await badgeNavigator.clearAppBadge();
        return true;
      }
      if (typeof badgeNavigator.setAppBadge === 'function') {
        await badgeNavigator.setAppBadge(0);
        return true;
      }
      return false;
    }

    if (typeof badgeNavigator.setAppBadge !== 'function') return false;
    await badgeNavigator.setAppBadge(Math.min(Math.floor(numericCount), 999));
    return true;
  } catch (err) {
    return false;
  }
}
